import * as Yup from 'yup'

const scoreRangeSchema = Yup.object().shape({
    minScore: Yup.number()
        .required('Score Mínimo é obrigatório!')
        .integer('Score Mínimo deve ser um número inteiro!')
        .min(0, 'Score Mínimo deve ser maior ou igual a 0!')
        .max(1000, 'Score Mínimo deve ser menor que 1000!'),
    maxScore: Yup.number()
        .typeError('Score Máximo é obrigatório!')
        .required('Score Máximo é obrigatório!')
        .integer('Score Máximo deve ser um número inteiro!')
        .min(0, 'Score Máximo deve ser maior ou igual a 0!')
        .max(1000, 'Score Máximo deve ser menor ou igual a 1000!')
        .test('is-greater', 'Score Máximo deve ser maior que o Score Mínimo da faixa!', function (value) {
            const { minScore } = this.parent
            return value > minScore
        }),
    creditLimitMinValue: Yup.number().min(0, 'Insira um valor válido!').nullable(),
    creditLimitMaxValue: Yup.number().min(1, 'Insira um valor válido!').nullable()
})

export default Yup.object().shape({
    name: Yup.string().required('Nome é obrigatório!'),
    description: Yup.string().required('Descrição é obrigatório!').max(200, 'Descrição pode conter no máximo 200 caracteres!'),
    isActive: Yup.bool().default(true),
    scoreRanges: Yup.array().of(scoreRangeSchema)
})
